import { render, staticRenderFns } from "./LineItemsComponent.vue?vue&type=template&id=dbb587b4&scoped=true"
import script from "./LineItemsComponent.vue?vue&type=script&lang=js"
export * from "./LineItemsComponent.vue?vue&type=script&lang=js"
import style0 from "./LineItemsComponent.vue?vue&type=style&index=0&id=dbb587b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb587b4",
  null
  
)

export default component.exports